const maindataRoutes = [
  {
    path: '/maindata/area',
    name: 'MainData_Area',
    component: () => import('@/pages/maindata/area'),
    meta: {keepAlive: true, name: '区域管理'},
  },
  {
    path: '/maindata/site',
    name: 'MainData_Site',
    component: () => import('@/pages/maindata/site'),
    meta: {keepAlive: true, name: '站点管理'},
  },
  {
    path: '/maindata/user',
    name: 'MainData_User',
    component: () => import('@/pages/maindata/user'),
    meta: {keepAlive: true, name: '人员管理'},
  },
  {
    path: '/maindata/sender',
    name: 'MainData_Sender',
    component: () => import('@/pages/maindata/sender'),
    meta: {keepAlive: true, name: '寄件方管理'},
  },

  {
    path: '/maindata/title',
    name: 'MainData_Title',
    component: () => import('@/pages/maindata/title'),
    meta: {keepAlive: true, name: '岗位管理'},
  },


]

export default maindataRoutes



// WEBPACK FOOTER //
// ./src/router/modules/maindata.js